var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/reactcss/~/lodash/_getPrototype.js
 ** module id = 1411
 ** module chunks = 0
 **/